/*------------------------------------*\
    GOOGLE MAP > CONTACT US
\*------------------------------------*/

 // MUST KEEP THIS SCRIPT OUTSIDE OF JQUERY DOCUMENT READY !!

var myEle = document.getElementById("map");
  // If #map exists then fire code
    if(myEle){

      var map;
      function initMap() {
        map = new google.maps.Map(
            document.getElementById('map'),
            {
            	center: new google.maps.LatLng(36.151694, -5.358713), 
            	zoom: 13,
                styles: [{"featureType":"landscape","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"stylers":[{"hue":"#00aaff"},{"saturation":-100},{"gamma":2.15},{"lightness":12}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"lightness":24}]},{"featureType":"road","elementType":"geometry","stylers":[{"lightness":57}]}],            });

        var iconBase =
            'https://design-dev.taurus.gi/_email-assets/';

        var icons = {
          parking: {
            icon: {

		        url: iconBase + 'office-map-marker.png',

		        // base image is 60x60 px
		        size: new google.maps.Size(94, 128),

		        // we want to render @ 30x30 logical px (@2x dppx or 'Retina')
		        scaledSize: new google.maps.Size(94, 128), 

		    },
          },
        };

        var features = [
		  {
            position: new google.maps.LatLng(36.144694, -5.358713),
            type: 'parking'
          },
        ];

        // Create markers.
        for (var i = 0; i < features.length; i++) {
          var marker = new google.maps.Marker({
            position: features[i].position,
            icon: icons[features[i].type].icon,
            map: map
          });
        };
      }

}
//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIiwic291cmNlcyI6WyJnb29nbGUtbWFwcy5qcyJdLCJmaWxlIjoiZ29vZ2xlLW1hcHMuanMifQ==
